import { useRef, useState, useEffect } from "react";
import { Box, Fab, Zoom } from "@mui/material";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import Navbar from "../components/LandingPage/Navbar";
import HeroSection from "../components/LandingPage/HeroSection";
import HowItWorks from "../components/LandingPage/HowItWorks";
import Footer from "../components/LandingPage/Footer";
import { useAuth } from "../../../common/provider";
import FeaturesSection from "../components/LandingPage/FeaturesSection";
import ProductIntroSection from "../components/LandingPage/ProductIntroSection";
import AboutSection from "../components/LandingPage/AboutSection";

const LandingPage = () => {
  const { toggleLoginDialog } = useAuth();

  // Ref for scrolling
  const howItWorksRef = useRef(null);
  const aboutSectionRef = useRef(null);
  
  // State to control the visibility of the scroll-to-top button
  const [showScrollTop, setShowScrollTop] = useState(false);

  // Function to scroll to top
  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth"
    });
  };

  // Detect scroll position to show/hide the button
  useEffect(() => {
    const handleScroll = () => {
      // Get the height of Navbar and HeroSection
      const navbarHeight = document.getElementById("app-bar")?.offsetHeight || 0;
      const heroSectionHeight = document.getElementById("hero-section")?.offsetHeight || 0;
      const threshold = navbarHeight + heroSectionHeight;
      
      // Show the button only when scrolled past the navbar and hero section
      if (window.scrollY > threshold) {
        setShowScrollTop(true);
      } else {
        setShowScrollTop(false);
      }
    };

    // Add scroll listener
    window.addEventListener("scroll", handleScroll);
    
    // Trigger once to set initial state
    handleScroll();
    
    // Clean up
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  return (
    <Box sx={{ position: 'relative' }}>
      <Navbar onLoginClick={toggleLoginDialog} />
      <HeroSection />
      <FeaturesSection />
      <ProductIntroSection />
      <HowItWorks />
      <AboutSection />
      <Footer />
      
      {/* Scroll to top button */}
      <Zoom in={showScrollTop}>
        <Fab 
          color="primary"
          size="medium"
          aria-label="scroll back to top"
          onClick={scrollToTop}
          sx={{
            position: 'fixed',
            bottom: 16,
            right: 16,
            zIndex: 1000,
            boxShadow: '0 4px 8px rgba(0,0,0,0.2)',
            backgroundColor: theme => theme.palette.primary.main,
            "&:hover": {
              backgroundColor: theme => theme.palette.primary.dark,
            }
          }}
        >
          <KeyboardArrowUpIcon />
        </Fab>
      </Zoom>
    </Box>
  );
};

export default LandingPage;